(function () {
	angular
		.module('trackeye')
		.factory('DeviceCollection', _DeviceCollectionFactory);

	_DeviceCollectionFactory.$inject = ['Device', 'C4ApiService', '$q', '$interval', 'config'];

	function _DeviceCollectionFactory(Device, api, $q, $interval, config) {
		function DeviceCollection() {
			// Every device related to the account
			this.devices = [];

			this.filtered = {
				sut: [],
				nonSut: [],
				prepaid: []
			};

			this._deferredQueue = undefined;
			this._queue = [];

			// Interval
			this.watchCollection = undefined;
			this.watchCallback = undefined;

			this.account = undefined;
		}

		/**
		 * Adds a one or more objects, containing device data to the list
		 * @param {(Resource|Resource[])} [data=Resource] - Array of/or unit Resource
		 * @return {Promise}
		 */
		DeviceCollection.prototype.initialize = function (account, data) {
			this.account = account;
			this._deferredQueue = $q.defer();

			this.flush();
			// Map device objects, to Device instances, and filter out instances where model is undefined
			this.devices = data.map(function(device) {
				device = new Device(device);
				return device;
			}).filter(function(device) {
				return device.getModel() !== undefined;
			});

			var now = (new Date()).getTime();

			api.sutmessages().last((function(data) {
				for (var i = 0; i < data.length; i++) {
					var nodeid = data[i].unit.number,
						device = this.find(nodeid);

					if (!device)
						continue;

					device.setInitialLatestMessage(data[i]);
				}

				// Sort the device list, based on their latest report.
				this.devices.sort(function(device1, device2) {
					var ts1 = device1.getTimescore(now),
						ts2 = device2.getTimescore(now);

					if (ts1 > ts2) {
						return -1;
					} else if (ts1 < ts2) {
						return 1;
					}
					return 0;
				});
			}).bind(this)).$promise.finally((this._initialLoad).bind(this));

			return this._deferredQueue.promise;
		};

		DeviceCollection.prototype._initialLoad = function() {
			collection = this;

			var models = collection.getUniqueModels(),
				toInitialize = [];

			api.modelfeatures(models).then(function(features) {
				collection.devices.forEach(function(device) {
					var model = device.getModel();
					device.setFeatures(features[model]);
					device.setLimitations();

					if (device.isPrepaid()) {
						device.setAppSubscription();
						collection.filtered.prepaid.push(device);
					}

					if (device.isSutDevice()) {
						collection.filtered.sut.push(device);
					} else {
						collection.filtered.nonSut.push(device)
					}
				});

				collection.loaded = toInitialize;
				collection._deferredQueue.resolve();
			});
		}

		DeviceCollection.prototype.postAdd = function (nodeid) {
			var defer = $q.defer();

			if (this.find(nodeid)) {
				defer.reject()
			} else {
				api.units().getOne({
					id: nodeid,
					include: "owner,permissions,configurations"
				}, (function (data) {
					var device = new Device(data);
					device.initialize().then(defer.resolve, defer.reject);

					this._setLatestMessage(device);
					this.devices.push(device);
				}).bind(this));
			}

			return defer.promise;
		};

		DeviceCollection.prototype._setLatestMessage = function (device) {
			api.sutmessages().singleLast({
				id: device.getUuid()
			}, function (data) {
				device.setLatestMessage(data);
			});
		};

		/**
		 * Flushes the list
		 * @return {DeviceCollection}
		 */
		DeviceCollection.prototype.flush = function () {
			this._queue.length = 0;

			this.devices.length = 0;

			this.filtered.sut.length = 0;
			this.filtered.nonSut.length = 0;
			this.filtered.prepaid.length = 0;

			// Stop the interval, checking for new messages
			$interval.cancel(this.watchCollection);
			return this;
		};

		/**
		 * Returns a array of unique models, generated from `this.devices`
		 */
		DeviceCollection.prototype.getUniqueModels = function() {
			return this.devices.map(function(device) {
				return device.getModel();
			}).filter(function(model, index, self) {
				return self.indexOf(model) === index;
			});
		}

		/**
		 * Checks if the list has any prepaid devices.
		 * @todo DeviceCollection should have a more generic traversal method
		 * @todo for checking multiple properties/methods
		 * @returns {boolean}
		 */
		DeviceCollection.prototype.hasPrepaidDevices = function () {
			return !!this.filtered.prepaid.length;
		};

		DeviceCollection.prototype.getFleets = function () {
			var fleets = [];

			for (var i = 0; i < this.devices.length; i++) {
				if (!this.devices[i].isActive())
					continue;

				var deviceFleet = this.devices[i].getFleet(),
					fleetName = deviceFleet.name;

				if (!fleetName)
					continue;

				var fleetMatch = fleets.find(function (fleet) {
					if (fleet && (fleet.name == fleetName))
						return fleet;
					return false;
				});

				if (fleetMatch) {
					fleetMatch.devices.push(this.devices[i]);
				} else {
					fleets.push({
						name: fleetName,
						fleet: deviceFleet,
						devices: [this.devices[i]]
					});
				}
			}
			return fleets;
		};

		/**
		 * Return all Sut devices
		 * @return {Device[]} Array of Device instances.
		 */
		DeviceCollection.prototype.sut = function () {
			return this.filtered.sut;
		};

		DeviceCollection.prototype.ownedSut = function () {
			return this.filtered.sut.filter((function(device) {
				return device.isOwner(this.account.getId());
			}).bind(this));
		};
		
		DeviceCollection.prototype.getPrepaidSut = function () {
			return this.filtered.prepaid.filter(function(device) {
				return device.isSutDevice();
			});
		};

		/**
		 * Return all non-Sut devices as an array
		 * @return {Device[]}   Array of Device instances.
		 */
		DeviceCollection.prototype.nonSut = function () {
			return this.filtered.nonSut;
		};

		/**
		 * Return all devices
		 * @return {Device|Device[]}   Array of Device instances.
		 */
		DeviceCollection.prototype.all = function () {
			return this.devices;
		};

		DeviceCollection.prototype.filtered = function () {
			return this.filtered;
		};


		/**
		 * Returns number of devices in list
		 * @returns {Number}
		 */
		DeviceCollection.prototype.count = function () {
			return this.devices.length;
		};

		/**
		 * Removes a device from the list
		 * @param {Device} [device=Device]
		 */
		DeviceCollection.prototype.remove = function (device) {
			for (var i = 0; i < this.devices.length; i++) {
				if (this.devices[i].nodeid == device.nodeid)
					this.devices.splice(i, 1);
			}
		};

		/**
		 * Alias of find()
		 *
		 * @param {string} [nodeid=3090512067] - Device nodeid (number
		 * @returns {Device} Device instance
		 */
		DeviceCollection.prototype.findOne = function (nodeid) {
			return this.find(nodeid)
		};

		/**
		 * Find a device by nodeid (number)
		 * @param  {string} [nodeid=3090512067] - Device nodeid (number)
		 * @return {Device} Device instance
		 */
		DeviceCollection.prototype.find = function (nodeid) {
			return this.findOneBy('nodeid', nodeid);
		};

		/**
		 * Find a device by a comparing a property to an value
		 * @param  {string} [property=nodeid] - Property on the Device instance
		 * @param  {(string|number|boolean)} [value=3090512067] - Value that the property should equal
		 * @returns {Device} Device instance
		 */
		DeviceCollection.prototype.findOneBy = function (property, value) {
			return this._traverseDevices(property, value)
		};

		/**
		 * Find a device by a comparing a property to an value
		 * @param  {string} [property=nodeid] - Property on the Device instance
		 * @param  {(string|number|boolean)} [value=3090512067] - Value that the property should equal
		 * @returns {Device|Device[]} Array of Device instances
		 */
		DeviceCollection.prototype.findBy = function (property, value) {
			return this._traverseDevices(property, value, true);
		};

		/**
		 * Iterate over devices, and return
		 *
		 * @param {string} [property=nodeid] - Property on the Device instance
		 * @param {(string|number)} [value=3090512067] - Value that the property should equal
		 * @param {boolean} [many=true] - Returns an array, instead of a single instance.
		 * @returns {(Device|Device[])} Device instance(s)
		 */
		DeviceCollection.prototype._traverseDevices = function (property, value, many) {
			var matches = [];
			for (var i = 0; i < this.devices.length; i++) {
				if (this.devices[i][property] == value) {
					if (!many)
						return this.devices[i];

					matches.push(this.devices[i]);
				}
			}

			if (!many)
				return null;

			return matches;
		};

		DeviceCollection.prototype._flushList = function () {
			this.list = [];
		};

		DeviceCollection.prototype.watchForUpdates = function (callback) {
			this.watchCallback = callback;
			this.watchCollection = $interval((function () {
				api.sutmessages().last({}, (function (data) {
					this.watchCallback(data);
					// for (var i = 0; i < data.length; i++) {
					// 	var nodeid = data[i].unit.number,
					// 		device = this.find(nodeid);

					// 	if (!device)
					// 		continue;

					// 	device.updateLatestMessage(data[i], this.watchCallback);
					// }
				}).bind(this), angular.noop);
			}).bind(this), (config.device.update_internal * 1000));
		};

		return DeviceCollection;
	}
})();